/*
 *Dev Dashboard
*/
export const GET_PROFILING_TAGS = 'GET_PROFILING_TAGS';
export const GET_PROFILING_TAGS_SUCCESS = 'GET_PROFILING_TAGS_SUCCESS';
export const GET_PROFILING_TAGS_ERROR = 'GET_PROFILING_TAGS_ERROR';

export const GET_AGGR_TAGS_DATA = 'GET_AGGR_TAGS_DATA';
export const GET_AGGR_TAGS_DATA_SUCCESS = 'GET_AGGR_TAGS_DATA_SUCCESS';
export const GET_AGGR_GROUP_BY_TAGS_DATA_SUCCESS = 'GET_AGGR_GROUP_BY_TAGS_DATA_SUCCESS';
export const GET_AGGR_TAGS_DATA_ERROR = 'GET_AGGR_TAGS_DATA_ERROR';

export const GET_API_TIMINGS_DATA = 'GET_API_TIMINGS_DATA';
export const GET_API_TIMINGS_DATA_SUCCESS = 'GET_API_TIMINGS_DATA_SUCCESS';
export const GET_API_TIMINGS_DATA_ERROR = 'GET_API_TIMINGS_DATA_ERROR';
export const EXPORT_API_TIMINGS_DATA = 'EXPORT_API_TIMINGS_DATA';
export const EXPORT_API_TIMINGS_DATA_SUCCESS = 'EXPORT_API_TIMINGS_DATA_SUCCESS';
export const EXPORT_API_TIMINGS_DATA_ERROR = 'EXPORT_API_TIMINGS_DATA_ERROR';

export const GET_API_DATA_BY_ID = 'GET_API_DATA_BY_ID';
export const GET_API_DATA_BY_ID_SUCCESS = 'GET_API_DATA_BY_ID_SUCCESS';
export const GET_API_DATA_BY_ID_ERROR = 'GET_API_DATA_BY_ID_ERROR';

//DMS specific
export const GET_DMS_LOGS_STREAMS = 'GET_DMS_LOGS_STREAMS';
export const GET_DMS_LOGS_STREAMS_SUCCESS = 'GET_DMS_LOGS_STREAMS_SUCCESS';
export const GET_DMS_LOGS_STREAMS_ERROR = 'GET_DMS_LOGS_STREAMS_ERROR';

export const GET_DMS_STATS_DATA = 'GET_DMS_STATS_DATA';
export const GET_DMS_STATS_DATA_SUCCESS = 'GET_DMS_STATS_DATA_SUCCESS';
export const GET_DMS_STATS_DATA_ERROR = 'GET_DMS_STATS_DATA_ERROR';

export const GET_DMS_LOGS_DATA = 'GET_DMS_LOGS_DATA';
export const GET_DMS_LOGS_DATA_SUCCESS = 'GET_DMS_LOGS_DATA_SUCCESS';
export const GET_DMS_LOGS_DATA_ERROR = 'GET_DMS_LOGS_DATA_ERROR';

//Rules Validator specific
export const GET_RULE_NAMES = 'GET_RULE_NAMES';
export const GET_RULE_NAMES_SUCCESS = 'GET_RULE_NAMES_SUCCESS';
export const GET_RULE_NAMES_ERROR = 'GET_RULE_NAMES_ERROR';

export const GET_RULE_LOGS = 'GET_RULE_LOGS';
export const GET_RULE_LOGS_SUCCESS = 'GET_RULE_LOGS_SUCCESS';
export const GET_RULE_LOGS_ERROR = 'GET_RULE_LOGS_ERROR';

export const GET_RULE_STATS = 'GET_RULE_STATS';
export const GET_RULE_STATS_SUCCESS = 'GET_RULE_STATS_SUCCESS';
export const GET_RULE_STATS_ERROR = 'GET_RULE_STATS_ERROR';

export const GET_PRODUCTS_NAMES = 'GET_PRODUCTS_NAMES';
export const GET_PRODUCTS_NAMES_SUCCESS = 'GET_PRODUCTS_NAMES_SUCCESS';
export const GET_PRODUCTS_NAMES_ERROR = 'GET_PRODUCTS_NAMES_ERROR';

export const GET_ACCOUNTS_LIST = 'GET_ACCOUNTS_LIST';
export const GET_ACCOUNTS_LIST_SUCCESS = 'GET_ACCOUNTS_LIST_SUCCESS';
export const GET_ACCOUNTS_LIST_ERROR = 'GET_ACCOUNTS_LIST_ERROR';

export const GET_RULE_LOG_DETAILS = 'GET_RULE_LOG_DETAILS';
export const GET_RULE_LOG_DETAILS_SUCCESS = 'GET_RULE_LOG_DETAILS_SUCCESS';
export const GET_RULE_LOG_DETAILS_ERROR = 'GET_RULE_LOG_DETAILS_ERROR';
